import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import * as LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';
import { invokeApig } from '../libs/awsLib';
import SeedInventoryButton from './SeedFridgeInventory/SeedInventoryButton';

/* TODO: understand why eslint say that `isLoading` unused */
/* eslint-disable react/no-unused-state */

export default class ViewLocationSchedule extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: true,
      seedInventoryEnabled: false,
      response: {
        permissions: [],
      },
    };
  }

  async UNSAFE_componentWillMount() {
    this.getUserPermissions();
  }

  async componentDidMount() {
    try {
      const currentID =
        window.location.pathname.split('/')[
          window.location.pathname.split('/').length - 1
        ];
      this.locationId = currentID;
      const test = await invokeApig({
        path: `/locations/${currentID}/schedule`,
        method: 'GET',
      });
      this.setState({
        events: JSON.parse(test.body),
        isLoading: false,
      });
    } catch (e) {
      alert(e);
      this.setState({
        isLoading: false,
      });
    }
    try {
      const user = await Auth.currentAuthenticatedUser();
      const ldclient = LDClient.initialize(
        process.env.REACT_APP_LAUNCH_DARKLY_CMS || 'nlfaepofjeowiajfpoijewr',
        { key: user.signInUserSession.idToken.payload.email },
      );
      ldclient.on('ready', () => {
        this.setState({
          seedInventoryEnabled: !!ldclient.allFlags()['seed-fridge-inventory'],
        });
      });
    } catch (e) {
      // leave button hidden on LD failure
    }
  }

  async getUserPermissions() {
    try {
      const test = await invokeApig({
        path: '/users/permissions',
        method: 'GET',
      });
      this.setState({
        response: JSON.parse(test.body),
        isLoading: false,
      });
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    return (
      <div>
        <div style={{ padding: '12px 0', textAlign: 'right' }}>
          <SeedInventoryButton
            locationId={this.locationId}
            enabled={this.state.seedInventoryEnabled}
          />
        </div>
        <Table bordered responsive>
          <thead>
            <tr key="header-table">
              <th key="Location">Location Name</th>
              <th key="LocationId">Location ID</th>
            </tr>
          </thead>
          <tbody>
            {this.state.response.permissions
              .filter((user) => this.state.response.users[user.uuid] !== '')
              .map((user) => (
                <tr key={user.action + user.uuid}>
                  <td>{this.state.response.users[user.uuid]}</td>
                  <td>{user.action}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }
}
